import jApi from './jApi';

export default {
  getSecurityApplication(params) {
    const api = jApi.generateApi();
    return api.get(`/nocode/dynamic-apps/security-application/get?application_id=${params}`)
      .then(res => res.data);
  },
  getSecurityPages(data) {
    const api = jApi.generateApi();
    if (data.filter) {
      return api.get(`/nocode/dynamic-apps/security-page/get?application_id=${data.applicationId}&filter=${JSON.stringify(data.filter)}`)
        .then(res => res.data);
      // eslint-disable-next-line no-else-return
    } else {
      return api.get(`/nocode/dynamic-apps/security-page/get?application_id=${data.applicationId}`)
        .then(res => res.data);
    }
  },
  setSecurityApplication(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/dynamic-apps/security-application/set', params)
      .then(res => res.data);
  },
  setSecurityPages(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/dynamic-apps/security-page/set', params)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiSecurityPage.js